<template>
<div :id="id" class='mMeduce' fillHeight="lastHeight" scroll ref="detailContent">
	<div class="mb1x vaT_E  w65pct fL">
		<!-- 系统概要start -->
		<StationSummary ref="StationSummary" @stepTo="summaryStepTo"></StationSummary>
		<!-- 系统概要end -->
		<!-- 发电历史start -->
		<generateHistory ref="generateHistory" StationType='wind' :baseInfo='basicInfo' :collectTime='stationInfo' :timeZoneCode="basicInfo.region.timezone"></generateHistory>
		<!-- 发电历史end -->
		<!-- 电站信息摘要start -->
<div class="pl05x pr05x clearfix fL_E w100pct_E pl05x_E pr05x_E">
			<!-- 发电实时start -->
			<div>
				<GeneratePower type="wind" ref="GeneratePower"></GeneratePower>
			</div>
			<!-- 节能减排start -->
			<!-- <div class="vaT">
				<SaveEnergy ref="SaveEnergy"></SaveEnergy>
			</div> -->

		</div>
		<!-- 电网实时
		<div v-if="basicInfo&&'EXCESS,BATTERY_BACKUP'.indexOf(basicInfo.gridInterconnectionType)>=0">
			<GridPower ref="GridPowerInfo"></GridPower>
		</div> -->
		<!-- 图表数据 -->
		<!-- <div v-if=" basicInfo && basicInfo.gridInterconnectionType=='EXCESS'">
			<generateHistoryExcess ref="generateHistoryExcess" :gridInterconnectionType='"BATTERY_BACKUP"'></generateHistoryExcess>
		</div> -->
    	<!-- 电池实时
		<div  v-if=" basicInfo && basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
			<GridBattery ref='gridBattery'></GridBattery>
		</div> -->
    <!-- 储能图表
    <div  v-if=" basicInfo && basicInfo.gridInterconnectionType=='BATTERY_BACKUP'">
      <generateHistoryBattery ref="generateHistoryBattery" :gridInterconnectionType='"BATTERY_BACKUP"'></generateHistoryBattery>
    </div> -->

		<div class="tableSys pl1x pr1x vaT_E">
			<!-- 天气start -->
			<!-- <div>
				<weather ref="weather"></weather>
			</div> -->
			<!-- 天气end -->
			<div class="w1x"></div>
			<div>
				<!-- <StationBasicInfo deviceType='installedCapacity,startOperatingTime,startOperatingStatus,contactPhone' ref="StationBasicInfo" @stepTo="$emit('stepTo','stationInfo')"></StationBasicInfo> -->
				<!-- <Pr ref="PrRing"></Pr> -->
			</div>
		</div>
    <div v-if=" basicInfo" class="tableSys vaT_E mt1x pl1x pr1x">
    <ChildSysTab :baseInfo='basicInfo'  @changetree='changetree'/>
    	
		</div>
	</div>
   <div class='fL w35pct pr1x'>
    <div>
				<StationBasicInfo ref="StationBasicInfo" @stepTo="$emit('stepTo','stationInfo')"></StationBasicInfo>
				<!-- <Pr ref="PrRing"></Pr> -->
			</div>
      <div>
      <!-- 逆变器排序 -->
      <InverterRank @stepTo="summaryStepTo" :stationInfo='basicInfo'></InverterRank>
    </div>

    <!-- 节能减排start -->
			<div class="vaT">
				<SaveEnergy ref="SaveEnergy"></SaveEnergy>
			</div>
      	<!-- 天气start -->
			<div>
				<weather ref="weather"></weather>
			</div>
			<!-- 天气end -->
  </div>
</div>
</template>
<script>
import { mapGetters, mapMutations, mapActions} from 'vuex'

import * as lib from '@/util/lib.js'
import {searchAreaList} from '@/api/base.js'
import {getLocal} from '@/util'
import * as equipmentApi from '@/api/maintain/plant/list'
import Loading from '@/components/common/ui/Loading'
import {getLanguageStr} from '@/util/language.js'

import ChildSysTab from '@/view/maintain/light/plant/detail/ChildSysTab.vue' // 计划发电量
import InverterRank from '@/view/maintain/light/plant/detail/inverterRank.vue' // 逆变器排名
import generateHistory from '@/view/maintain/light/plant/detail/GenerateHistory' // 发电历史
import generateHistoryExcess from '@/view/maintain/light/plant/detail/GenerateHistoryExcess' // 自发自用历史
import generateHistoryBattery from '@/view/maintain/light/plant/detail/GenerateHistoryBattery' // 自发自用历史
import StationSummary from '@/view/maintain/light/plant/detail/StationSummary' // 信息摘要
import SaveEnergy from '@/view/maintain/light/plant/detail/SaveEnergy' // 节能
import GeneratePower from '@/view/maintain/light/plant/detail/GeneratePower' // 实时发电
import UsePower from '@/view/maintain/light/plant/detail/UsePower' // 用电实时
import FlowChart from '@/view/maintain/light/plant/detail/FlowChart' // 流程图
import FlowChartStorage from '@/view/maintain/light/plant/detail/FlowChart_storage'
import GridPower from '@/view/maintain/light/plant/detail/GridPower' // 实时用电
import GridBattery from '@/view/maintain/light/plant/detail/GridBattery' // 实时用电
import StationBasicInfo from '@/view/maintain/light/plant/detail/StationBasicInfo.vue' // 电站基本信息摘要

import Pr from '@/view/maintain/light/plant/detail/Pr'
import weather from '@/view/maintain/light/plant/detail/Weather' // 天气

export default {
  components: {ChildSysTab, InverterRank, Loading, weather, generateHistory, generateHistoryExcess, Pr, StationSummary, GeneratePower, StationBasicInfo, SaveEnergy, UsePower, FlowChart, FlowChartStorage, GridPower, GridBattery, generateHistoryBattery},
  props: {
    basicInfo: {
      type: Object,
      default: {}
    },
    roleCode:{
      type: Array,
      default:(()=>{return [];})
    }
  },
  provide () {
    return {
      baseinfoProvideTime: this.basicInfo,
      stationInfoProvideTime: this.stationInfo
    }
  },
  data () {
    return {
      id: 'Detail' + Math.round(Math.random() * 99999),
      // basicInfo:{},
      stationInfo: {},
      stationId: null,
      systemId: null,
      isLoading: false,
      isAssign: true, // 实时数据状态
      metering: [], // 记录图表时需要用到的数据，从vuex里获取会有顺序差，导致数据不准确
      local: {},
      // metering:{},
      assignInfo: {}, // 实时数据
      timeDisable: false,
      DashWidth: 0
    }
  },
  computed: {
    ...mapGetters({
      // metering:'stationDetail/metering',
      // stationId: 'stationDetail/stationId',
    })
  },
  watch: {
  },
  created () {
  },
  methods: {
    doPermissions:lib.doPermissions,
    getLanguageStr,
    floatFix: lib.floatFix,
    convertData: lib.convertData,
    getTypeText: lib.getTypeText,
    changetree (item) {
      this.$emit('changetree', item)
    },
    ...mapMutations({
      CHANGE: 'equipment/CHANGE',
      GET_METERING: 'stationDetail/GET_METERING'
    }),
    clone (arr) {
      return _.cloneDeep(arr);
    },
    show (data) {
      this.stationId = data.stationId,
      this.systemId = data.systemId
      this.stationInfo = data.stationInfo
      this._getAllInfo(data.stationId)
      this.$refs.StationSummary.show({ // 打开系统概要
        stationId: this.stationId,
        systemId: this.systemId,
        level: 0
      })
      // this.$refs.PrRing.show({
      // 	stationId:this.stationId,
      // 	stationInfo:data.stationInfo
      // })
      this.$refs.GeneratePower.show({ // 实时
        stationId: this.stationId,
        systemId: this.systemId,
        level: 0,
        stationInfo: data.stationInfo
      })
      this.$refs.SaveEnergy.show({ // 节能减排
        stationId: this.stationId,
        systemId: this.systemId,
        level: 0,
        stationInfo: data.stationInfo
      })
    },
    _getAllInfo (id) {
      Promise.all([this.getBasicInfo(id), this.getMetering(id)]).then(res => {
        this.metering = res[1]
        this.$refs.weather.show({id: this.stationId, basicInfo: this.basicInfo}) // 根据返回信息，查找天气
        this.$refs.StationBasicInfo && this.$refs.StationBasicInfo.show({
          stationId: this.stationId,
          basicInfo: this.basicInfo,
          metering: res[1]
        })
        this.$refs.generateHistory.show({ // 打开历史图表
          stationId: this.stationId,
          systemId: this.systemId,
          level: 0,
          basicInfo: this.basicInfo
        })
        if (this.basicInfo.gridInterconnectionType == 'EXCESS') {
          this.$nextTick(() => {
            this.$refs.UsePowerInfo.show({ // 打开用电实时
              stationId: this.stationId,
              systemId: this.systemId,
              level: 0,
              stationInfo: this.stationInfo
            })
            this.$refs.FlowChart.show({// 打开流程图
              stationId: this.stationId,
              stationInfo: this.stationInfo
            })
            this.$refs.generateHistoryExcess.show({// 打开自发自用历史图表
              stationId: this.stationId,
              systemId: this.systemId,
              assignInfo: this.basicInfo,
              metering: res[1]
            })
            this.$refs.GridPowerInfo.show({
              stationId: this.stationId,
              systemId: this.systemId,
              level: 0,
              stationInfo: this.stationInfo
            })
          })
        }
        if (this.basicInfo.gridInterconnectionType == 'BATTERY_BACKUP') { // 储能场景
          this.$nextTick(() => {
            this.$refs.UsePowerInfo.show({ // 打开用电实时
              stationId: this.stationId,
              systemId: this.systemId,
              level: 0,
              stationInfo: this.stationInfo
            })
            // 自发自用图表
            this.$refs.GridPowerInfo.show({// 实时用电
              stationId: this.stationId,
              systemId: this.systemId,
              level: 0,
              stationInfo: this.stationInfo
            })
            this.$refs.generateHistoryBattery.show({// 打开自发自用历史图表
              stationId: this.stationId,
              systemId: this.systemId,
              assignInfo: this.basicInfo,
              metering: res[1]
            })
            this.$refs.gridBattery.show({
              stationId: this.stationId,
              systemId: this.systemId,
              level: 0,
              stationInfo: this.stationInfo
            })
            this.$refs.FlowChartStorage.show({// 储能流动图
              stationId: this.stationId,
              stationInfo: this.stationInfo
            })
          })
        }
        this.GET_METERING(res[1])
        //      if (res[1].repeatedHint) { // 是否触发重复提示
        //        this.$emit('repeatHint')
        //      }
        setTimeout(lib.fillHeight, 500)
      }, error => {
        this.isLoading = false
        !_.isEmpty(error) && this.$notify(error)
      })
    },
    // 获取详情-电站信息
    getBasicInfo (id) {
      // return new Promise((resolve,reject)=>{
      // 	equipmentApi.StationBasicInfo(id).then(response=>{
      // 		resolve(response)
      // 	},error=>{
      // 		reject(reject)
      // 	})
      // })
    },
    // 获取理论自发自用率
    getMetering (id) {
      return new Promise((resolve, reject) => {
        equipmentApi.StationMetering(id).then(response => {
          resolve(response)
        }, error => {
          reject(error)
        })
      })
      // equipmentApi.StationMetering(id).then(response=>{
      // 	this.chartMetering=response
      // 	this.$refs.PrRing.show()
      // 	if(this.assignInfo.gridInterconnectionType=='EXCESS'){ //打开自发自用历史图表
      // 		this.$refs.generateHistoryExcess.show({
      // 			id:this.stationId,
      // 			assignInfo:this.assignInfo,
      // 			metering:response
      // 		})
      // 	}
      // 	this.GET_METERING(response)
      // 	if(response.repeatedHint){ //是否触发重复提示
      // 		this.$emit('repeatHint')
      // 	}
      // },error=>{
      // 	!_.isEmpty(error) && this.$notify(error)
      // })
    },
    // 系统概要跳转
    summaryStepTo (data) {
      this.$emit('stepToDevice', data)
    }
  },
  mounted () {
    lib.fillHeight()
    lib.setScroll($(this.$el))
  }
}
</script>
<style lang="scss" scoped>
#weatherInfo .icoSys svg{ padding: 10% }
.datepicker{width:125px !important;height:2.2em;line-height:2.2em}
.datepicker-range{min-width: auto;}
.textCut_E >.s-title{color:#000;max-width: 14em; display: inline-block; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;padding-left:2px}
// .fs18x{font-size:1.6em}
.clearfix::after{
	content: "";
	display: block;
	clear: both;
}
.realTimeInfo{
	min-height: 379px
}
.realTimeInfo ul.w33pct_E>*{
	width: 30%
}
@media screen and (max-width: 1660px){
	.realTimeInfo ul > *{
		width: 20%
	}
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/wind/plant/part/Detail.vue